import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import style from './style.vue';

@Component({
  components: {},
  mixins: [style],
})
export default class Order extends Vue {
  @Prop({ default: () => {} })
    value: DisplayOrderData;

  @Prop({ default: 1 })
    themeCode: number;

  // 分割线颜色
  get borderColor() {
    return this.themeCode > 3 ? '#333333' : '#f2f2f2';
  }

  // 区块背景色
  get blockBackground() {
    return this.themeCode > 3 ? '#181818' : '#ffffff';
  }

  isSvg(val = ''): boolean {
    const arr = val.split('.') || [];
    return arr.pop() === 'svg';
  }

  render(h) {
    return (
      <div class="order box-shadow" style={`background: ${this.blockBackground}`}>
        <div class="order-txt">我的订单</div>
        <div class="all-order">查看全部</div>
        <div class="order-type" style={`border-top: 1px solid ${this.borderColor};`}>
          <div>
            <img class="order-img" src={`${this.value.desc.list[0].url}${this.isSvg(this.value.desc.list[0].url) ? '' : '?imageView2/1/w/150/h/150'}`}></img>
            <p>待付款</p>
          </div>
          <div>
            <img class="order-img" src={`${this.value.desc.list[1].url}${this.isSvg(this.value.desc.list[1].url) ? '' : '?imageView2/1/w/150/h/150'}`}></img>
            <p>待发货</p>
          </div>
          <div>
            <img class="order-img" src={`${this.value.desc.list[2].url}${this.isSvg(this.value.desc.list[2].url) ? '' : '?imageView2/1/w/150/h/150'}`}></img>
            <p>待收货</p>
          </div>
          <div>
            <img class="order-img" src={`${this.value.desc.list[3].url}${this.isSvg(this.value.desc.list[3].url) ? '' : '?imageView2/1/w/150/h/150'}`}></img>
            <p>已完成</p>
          </div>
          <div>
            <img class="order-img" src={`${this.value.desc.list[4].url}${this.isSvg(this.value.desc.list[4].url) ? '' : '?imageView2/1/w/150/h/150'}`}></img>
            <p>退款/售后</p>
          </div>
        </div>
      </div>
    );
  }
}
